import {Serializers} from '../../interfaces/serializer';
import {DataSetConditionalDimension} from '../../interfaces/dimensions';
import {DimensionComponentObjects} from '../../classes/dimension-component-object';
import {DatasetConditionalDimensionComponentObjects} from '../../classes/dataset-conditional-dimension-component-object';

export const DATASET_CONDITIONAL_DIMENSIONS_STATE_NAME = 'datasetConditionalDimensions'

export interface DataSetConditionalDimensionsState {
  serialized: Serializers<DataSetConditionalDimension>;
  componentObjects: DatasetConditionalDimensionComponentObjects;
  loading: boolean;
  loaded: boolean;
  initialized: boolean;
}
